export const defaultState = () => {
    return {
        status: null,
        timestamp: null,
        readyForOffline: true
    }
}

const state = defaultState()
export default state
